'use strict';

module.exports = require('./src/js/main');
